import React from "react";
import { Modal, Box, Slide, Button, Typography, styled, Divider } from "@mui/material";
import { ReactComponent as Logo } from "assets/icons/logo.svg";
import { ReactComponent as SelectLogo } from "assets/icons/Select_Logo.svg";
import { ReactComponent as CreateLogo } from "assets/icons/Create_Logo.svg";
import { ReactComponent as NexusLogo } from "assets/icons/Nexus_Logo.svg";
import BrecoLogo from "assets/icons/Breco_New.png";
import { ReactComponent as CRMLogo } from "assets/icons/CRM_Logo.svg";
import RemoveModal from "../RemoveModal/RemoveModal";
import "./rightSideBarStyle.css";

const StyledButton = styled(Button)({
  width: "100%",
  fontFamily: "Poppins",
  fontWeight: 700,
  fontSize: "10px",
  lineHeight: "13px",
  height: "33px",
  borderRadius: "5px",
  color: "#FFF",
  border: "1px solid #fff",
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#fff",
    color: "#000",
  },
});

const isDev = process.env.REACT_APP_TITLE === "Binny's Vision Dev";

const APP_URLS = {
  design: isDev ? "https://dev.binnys.design/" : "https://binnys.design/",
  select: isDev ? "https://dev.select.binnys.app/" : "https://select.binnys.app/",
  create: isDev ? "https://dev.create.binnys.app/" : "https://create.binnys.app/",
  create: isDev ? "https://dev.create.binnys.app/" : "https://create.binnys.app/",
  nexus: isDev ? "https://dev.nexus.binnys.app/" : "https://nexus.binnys.app/",
  breco: isDev ? "https://breco.binnys.app/" : "https://breco.binnys.app/",
  crm: isDev ? "https://crm.binnys.app/" : "https://crm.binnys.app/",
};

function RightSideBarModal({ open, setOpen, modalBtnInfo, logoutModal, setLogoutModal }) {
  const handleClose = () => setOpen(false);

  return (
    <>
      <Modal open={open} onClose={handleClose} BackdropProps={{ style: { backgroundColor: "transparent" } }}>
        <Slide direction="left" in={open} timeout={500} mountOnEnter unmountOnExit>
          <Box className="main">
            {/* header and section */}
            <Box className="main-box">
              <Typography className="main-title">Apps</Typography>
              {/* cards */}
              <Box className="Cards-Row">
                {/* <Box className="Card-Content" onClick={() => window.open(APP_URLS.design, "_blank")}>
                  <Box className="Card-logo">
                    <Logo />
                  </Box>
                  <Typography className="Card-title">Design Web</Typography>
                </Box> */}
                <Box className="Card-Content" onClick={() => window.open(APP_URLS.nexus, "_blank")}>
                  <Box className="Card-logo">
                    <NexusLogo />
                  </Box>
                  <Typography className="Card-title">Nexus Web</Typography>
                </Box>
                <Box className="Card-Content" onClick={() => window.open(APP_URLS.crm, "_blank")}>
                  <Box className="Card-logo">
                    <CRMLogo />
                  </Box>
                  <Typography className="Card-title">CRM Web</Typography>
                </Box>
                <Box className="Card-Content" onClick={() => window.open(APP_URLS.select, "_blank")}>
                  <Box className="Card-logo">
                    <SelectLogo />
                  </Box>
                  <Typography className="Card-title">Select Web</Typography>
                </Box>
                <Box className="Card-Content" onClick={() => window.open(APP_URLS.create, "_blank")}>
                  <Box className="Card-logo">
                    <CreateLogo />
                  </Box>
                  <Typography className="Card-title">Create Web</Typography>
                </Box>
                <Box className="Card-Content" onClick={() => window.open(APP_URLS.breco, "_blank")}>
                  <Box className="Card-logo">
                    <img src={BrecoLogo} alt="Breco" style={{ width: "100%", height: "100%" }} />
                  </Box>
                  <Typography className="Card-title">Breco Web</Typography>
                </Box>
              </Box>
            </Box>
            {/* Footer */}
            <Box className="footer-modal">
              <StyledButton onClick={() => setLogoutModal(true)}>Logout</StyledButton>
            </Box>
          </Box>          
        </Slide>
      </Modal>
      {/*modal*/}
      <RemoveModal open={logoutModal} setOpen={setLogoutModal} btnInfo={modalBtnInfo} heading="Are you sure you want to log out?" />
    </>
  );
}

export default RightSideBarModal;